import { EmptyStateIllustration } from '@mdvip/shared/components/blocks/EmptyStateIllustration';
import type { PageTab } from '@mdvip/shared/components/blocks/PageTabs';
import { PageTabPanel, PageTabs } from '@mdvip/shared/components/blocks/PageTabs';
import { useTranslation } from 'react-i18next';
import { ClevelandHeartLab } from '@/components/resources/operations/ClevelandHeartLab';

export function ResourcesPage() {
  const { t } = useTranslation('providers');

  // The Tabs handoff only specifies glyphs for the members Payment Center bar, so these reuse
  // existing entries from the shared glyph map rather than introducing new ones.
  const tabs: PageTab[] = [
    { value: 'medical', label: t('pages.resources.tabs.medical'), icon: 'stethoscope' },
    { value: 'operations', label: t('pages.resources.tabs.operations'), icon: 'building' },
    { value: 'wellness', label: t('pages.resources.tabs.wellness'), icon: 'dumbbell' },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold">{t('pages.resources.title')}</h1>
        <p className="text-sm text-muted-foreground mt-1">{t('pages.resources.subtitle')}</p>
      </div>
      <PageTabs tabs={tabs} defaultValue="medical">
        <PageTabPanel value="medical">
          <div className="flex flex-col items-center justify-center border-2 border-dashed border-border rounded-xl py-16 gap-4">
            <EmptyStateIllustration className="w-48 opacity-40" />
            <p className="text-muted-foreground text-sm">{t('pages.resources.empty.medical')}</p>
          </div>
        </PageTabPanel>
        <PageTabPanel value="operations">
          <ClevelandHeartLab />
        </PageTabPanel>
        <PageTabPanel value="wellness">
          <div className="flex flex-col items-center justify-center border-2 border-dashed border-border rounded-xl py-16 gap-4">
            <EmptyStateIllustration className="w-48 opacity-40" />
            <p className="text-muted-foreground text-sm">{t('pages.resources.empty.wellness')}</p>
          </div>
        </PageTabPanel>
      </PageTabs>
    </div>
  );
}
